import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchProjects = createAsyncThunk(
    "projects/fetchProjects",
    async (params, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get("api/project", { params });
            const result = response.data;
            const data = result?.data || result;
            
            // Standardize item extraction across different API response patterns
            let items = [];
            if (Array.isArray(data)) {
                items = data;
            } else if (data && typeof data === "object") {
                items = Array.isArray(data.items) ? data.items
                    : Array.isArray(data.projects) ? data.projects
                    : Array.isArray(data.rows) ? data.rows
                    : Array.isArray(data.results) ? data.results
                    : [];
            }

            return {
                items,
                pagination: data?.pagination || result?.pagination || null
            };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const fetchAllProjects = createAsyncThunk(
    "projects/fetchAllProjects",
    async (params, { rejectWithValue }) => {
        try {
            // Dropdowns should typically request all items, but we'll allow params if needed
            const response = await axiosInstance.get("api/project", { params });
            const result = response.data;
            const data = result?.data || result;
            
            let items = [];
            if (Array.isArray(data)) {
                items = data;
            } else if (data && typeof data === "object") {
                items = Array.isArray(data.items) ? data.items
                    : Array.isArray(data.projects) ? data.projects
                    : Array.isArray(data.rows) ? data.rows
                    : Array.isArray(data.results) ? data.results
                    : [];
            }

            return items;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const deleteProjects = createAsyncThunk(
    "projects/deleteProjects",
    async (ids, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete("api/project", {
                data: { ids }
            });
            return { ids, message: response.data?.message || "Projects deleted successfully" };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
